import actions from './actions';

const ClaimSettingPINSettingModule = {
  namespaced: true,
  actions,
};

export default ClaimSettingPINSettingModule;
